module.exports = __webpack_public_path__ + "img/school4.379934c3.png";